import { Component } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { DatePipe, NotificationComponent } from '@tdwb/core';
import { AgreementsDateBaseDirective } from '../agreements.base';

@Component({
  selector: 'td-wb-russel-agreement',
  templateUrl: './russel-agreement.component.html',
  styleUrls: ['../agreements.component.scss'],
  imports: [NgTemplateOutlet, NotificationComponent, DatePipe]
})
export class RusselAgreementComponent extends AgreementsDateBaseDirective {
}
